import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { checkUser } from "../api/UserApi";
import { dynamicFailed } from "../hooks/useToast";
import { openLogin } from "../exports/exports";

const Login = () => {
  const accessToken = localStorage.getItem("frcsit:access-token");
  const navigate = useNavigate();
  const [callOnce, setCallOnce] = useState(false);
  useEffect(() => {
    if (callOnce && (accessToken === null || accessToken === undefined)) {
      openLogin();
    }
    if (accessToken === null || accessToken === undefined) {
      setCallOnce(true);
      return;
    }
    Promise.all([checkUser(accessToken)])
      .then(([userData]) => {
        if (!userData) {
          openLogin();
        } else {
          userData?.data?.roles[0]?.name === "sa"
            ? navigate("/admin/dashboard")
            : navigate("/member/dashboard");
        }
      })
      .catch(() => {
        dynamicFailed("Server Error");
      });
  }, [accessToken, callOnce, navigate]);
  return <></>;
};

export default Login;
